import BaseModelAPI from '../BaseModelAPI';

export default class StandarTimeCategoryList extends BaseModelAPI {

	static entity = 'standartimecategorylist'
	static entityName = 'standartimecategory';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
